// servicesData.js
export const services = [
  {
    title: "Power Quality Analysis",
    description:
      "Analyzes voltage, current, and power factors to improve electrical system efficiency.",
    details:
      "We use advanced tools to detect harmonics, transients, and imbalances to ensure optimal performance.",
    keywords: [
      /* natural-language questions */
      "what is power quality",
      "what is power quality analysis",
      "explain power quality analysis",
      "tell me about power quality",
      "how to improve power quality",
      "how does power quality analysis work",
      "power quality meaning",
      "power quality study",
      "power quality troubleshooting",
      /* specific technical terms */
      "power quality",
      "power factor correction",
      "power factor analysis",
      "voltage drop",
      "voltage imbalance",
      "harmonic distortion",
      "total harmonic distortion",
      "THD",
      "transient spikes",
      "current issues",
      "electrical efficiency",
      "harmonics",
      "power quality monitoring"
    ]
  },

  {
    title: "Smart Grid Monitoring",
    description:
      "Monitors modern electrical grids using IoT and data analytics.",
    details:
      "Our system provides real-time insights into grid performance, faults, and demand forecasting.",
    keywords: [
      /* natural-language questions */
      "what is smart grid monitoring",
      "explain smart grid monitoring",
      "tell me about smart grids",
      "how does smart grid monitoring work",
      "smart grid meaning",
      "smart grid advantages",
      /* specific technical terms */
      "smart grid",
      "smart grid monitoring",
      "grid performance",
      "electric grid monitoring",
      "real-time grid",
      "IoT energy systems",
      "smart meters",
      "energy analytics",
      "grid analytics",
      "power distribution monitoring",
      "grid fault detection",
      "demand forecasting"
    ]
  },

  {
    title: "AMMS",
    description:
      "Asset Monitoring and Management System for utility infrastructures.",
    details:
      "Track asset performance, schedule maintenance, and manage lifecycle efficiently.",
    keywords: [
      /* natural-language questions */
      "what is AMMS",
      "explain AMMS",
      "tell me about AMMS",
      "what is asset monitoring and management system",
      "how does AMMS work",
      "utility asset monitoring",
      /* specific technical terms */
      "asset monitoring",
      "asset management system",
      "equipment management",
      "utility tracking",
      "maintenance system",
      "asset performance",
      "AMMS platform",
      "asset lifecycle",
      "utility asset manager",
      "predictive maintenance",
      "condition monitoring"
    ]
  },

  {
    title: "Transformer Inspection",
    description:
      "Detailed inspection and maintenance of transformers.",
    details:
      "We inspect insulation, oil quality, thermal imaging, and load analysis to prevent failures.",
    keywords: [
      /* natural-language questions */
      "what is transformer inspection",
      "explain transformer inspection",
      "tell me about transformer maintenance",
      "how to inspect a transformer",
      "transformer inspection procedure",
      "transformer health check",
      /* specific technical terms */
      "transformer inspection",
      "transformer diagnostics",
      "transformer oil testing",
      "oil quality test",
      "load analysis",
      "thermal inspection",
      "thermal imaging transformer",
      "transformer faults",
      "preventive transformer maintenance",
      "insulation analysis",
      "dissolved gas analysis",
      "DGA test"
    ]
  },
    {
    title: "About Circuitech",
    description: "CIRCUITECH – Powering efficiency, enhancing performance. Your trusted engineering partner in power, energy and automation.",
    details: `Built for Performance. Engineered for the Future.

What We Do:
- Technology & Innovation: We offer cutting-edge solutions in electrical and software systems.
- Expertise & Experience: Driven by industry professionals with lustrum of experience.
- Global Reach: Serving clients across the UAE and beyond.`,
    keywords: [
      "circuitech",
      "what is circuitech",
      "about circuitech",
      "circuitech company profile",
      "engineering company UAE",
      "power and automation UAE",
      "electrical engineering firm",
      "energy solutions provider",
      "automation services",
      "circuitech services",
      "electrical and software solutions",
      "innovation in power systems",
      "trusted engineering partner",
      "built for performance"
    ]
  }
];
